import { useEffect } from "react";

const extractGAId = (url: string): string | null => {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.searchParams.get("id");
    } catch {
        return null;
    }
};

const useGoogleAnalytics = (gaUrl?: string) => {
    useEffect(() => {
        if (!gaUrl) return;

        const gaId = extractGAId(gaUrl);
        if (!gaId) return;

        // Script zaten ekli mi?
        if (!document.querySelector(`script[src*="gtag/js?id=${gaId}"]`)) {
            const script = document.createElement("script");
            script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            script.async = true;
            document.head.appendChild(script);
        }

        // Her tenant değiştiğinde config bas
        if (window.gtag) {
            window.gtag("config", gaId);
        }
    }, [gaUrl]);
};


export default useGoogleAnalytics;
